import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EModelApiPaths } from '../enums/EModelApiPaths';
import { AuthService } from './auth.service';
import { BaseService } from './base-service';
import { UserService } from './user.service';
import { UtilsService } from "./utils.service";
import { ECollection } from "../enums/ECollection";
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OrdersService extends BaseService {
    constructor(public override http: HttpClient,
                public override utilsService: UtilsService,
                public override userService: UserService,
                public authService: AuthService) {
        super(http, userService, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.DB}/${ECollection.SW_ORDERS}`);
    }


    async trackOrder<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.SHIPROCKET_TRACK_YOUR_ORDER, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async calculateShippingCharge<T>(body: any) {
        const encryptedData = this.userService.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.SWEVENNE_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.SHIPROCKET_CALCULATE_SHIPPING_CHARGE, encryptedData, this.userService.getRequestOptions()).toPromise();
        if (environment.IS_ENCRYPTED) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

}
